// Copyright 2018-2023 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import ConfirmDialog from "./ConfirmDialog";

export default ConfirmDialog;
